import { useCallback } from 'react';
import { useCustomerNavigate } from 'hooks/useCustomerNavigate';
import { TJobStatus, TObjectJobSummary } from 'types/objectJob.type';
import {
  Button,
  ConfirmationPopup,
  Icon,
  Typography,
} from '@timeedit/ui-components';
import { useDeleteJobMutation } from './api/objectJobApi';

type JobActionsProps = {
  job: TObjectJobSummary;
};

const DELETABLE_STATUSES: TJobStatus[] = [
  'FAILED',
  'FINISHED',
  'PENDING_REVIEW',
];

export const JobActions = ({ job }: JobActionsProps) => {
  const navigate = useCustomerNavigate();
  const [deleteJob, { isLoading: isDeleting }] = useDeleteJobMutation();

  const handleDelete = useCallback(async () => {
    try {
      await deleteJob({ jobId: job.id }).unwrap();
    } catch {
      return;
    }
  }, [deleteJob, job.id]);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span style={{ width: 36, marginRight: 10, display: 'inline-flex' }}>
        {DELETABLE_STATUSES.includes(job.status) && (
          <ConfirmationPopup
            icon={<Icon alt="Warning" id="Warning" />}
            message="Are you sure you want to remove this operation from the list? Note: The included objects will not be affected by removing the job from the list"
            onConfirm={handleDelete}
            okText="Remove"
            cancelText="Keep"
          >
            <Button
              type="text"
              size="small"
              style={{ border: '1px solid #00000073' }}
              icon={<Icon id="DeleteOutlined" alt="Delete" />}
              loading={isDeleting}
              disabled={isDeleting}
            />
          </ConfirmationPopup>
        )}
      </span>
      <Typography.Link onClick={() => navigate(`/objects/jobs/${job.id}`)}>
        View Details
      </Typography.Link>
    </span>
  );
};
